(function () {
  "use strict";

  HomeCtrl.$inject = ['$scope', '$rootScope', '$window', 'trainerPrivilege', 'homePreferencesService', 'resolveData', 'mtypes', 'homeResource', '$location', 'trackingService', 'homeSearchService', 'accountFeatures', 'authView', 'sortHelper', 'catalogResource', 'actionLogResource'];
  angular
    .module('trainerWebApp.controllers')
    .controller('HomeCtrl', HomeCtrl);

  function HomeCtrl($scope, $rootScope, $window, trainerPrivilege, homePreferencesService, resolveData, mtypes, homeResource,
                    $location, trackingService, homeSearchService, accountFeatures, authView, sortHelper, catalogResource,
                    actionLogResource) {

    $window.document.title = "Home | Mindflash Training Management System";
    $rootScope.page = {name: 'home', title: "Home"};
    var gaActions = trackingService.pages.trainerHome.actions;
    var userRole = trainerPrivilege.roles();

    var homeConfig = {
      sidebarSrcs: {
        series: 'pages/home/homeSeriesSidebar.html',
        online: 'pages/home/homeCourseSidebar.html',
        live: 'pages/home/homeCourseSidebar.html',
        free: 'pages/home/freeContentSidebar.html',
        catalog: 'pages/home/homeCatalogSidebar.html'
      },
      sampleCourseIds: [mfConfig.sampleCourseId, mfConfig.YammerSampleCourseID],
      gaActions: {
        view: {
          tile: gaActions.viewChangeToTile,
          list: gaActions.viewChangeToList
        },
        status: {
          all: gaActions.searchFilterStatusAll,
          draft: gaActions.searchFilterStatusDraft,
          active: gaActions.searchFilterStatusActive,
          archive: gaActions.searchFilterStatusArchive
        },
        type: {
          all: gaActions.searchFilterTypeAll,
          online: gaActions.searchFilterTypeCourse,
          series: gaActions.searchFilterTypeSeries
        },
        tileViewSort: {
          name: gaActions.tileSearchSortName,
          modified: gaActions.tileSearchSortModified,
          trainerName: gaActions.tileSearchSortTrainerName
        },
        click: {
          manageUsersButton: gaActions.manageUsersButtonClicked
        }
      },
      viewUrls: {
        tile: 'pages/home/homeTileView.html',
        list: 'pages/home/homeListView.html'
      }
    };

    var homeState = $scope.homeState = {
      sidebarContentSrc: null,
      selectedItem: null,
      viewPreferences: {
        sortField: 'modified',
        sortDirection: 'desc',
        view: 'tile',
        typeFilter: 'all',
        statusFilter: 'all'
      },
      view: {
        showLiveTraining: false,
        showTypeFilter: true,
        showStatusFilter: true,
        showSortDropdown: false,
        showCreateCourseButton: false,
        showSeriesFeaturePreview: false
      },
      permissions: {
        canCreateCourses: true,
        canCreateSeries: true,
        canCreateCatalog: true,
        canViewCatalogs: true,
        canViewDraftCourses: true
      },
      activeServerCalls: {
        courseCreation: false,
        seriesCreation: false
      },
      search: {
        typeFilter: 'all',
        statusFilter: 'all',
        compositeSearchFilter: null,
        data: {},
        updating: false
      },
      goodData: {
        enabled: authView.showGoodData()
      }
    };

    var items = $scope.items = [];

    function setup(homeItems) {
      if (homeItems.catalogs) {
        _.each(homeItems.catalogs, function (item) {
          item.type = 'catalog';
        });

        items = $scope.items = (homeItems.coursesAndSeries.concat(homeItems.catalogs) || []);
      } else {
        items = $scope.items = (homeItems.coursesAndSeries || []);
      }

      // prefs
      homePreferencesService.initializePreferences(homeItems.homePreferences);

      var viewPreferences = homePreferencesService.getPreferences();

      if (viewPreferences)
        homeState.viewPreferences = viewPreferences;

      // if you don't have the series feature, disable the type filter
      homeState.view.showTypeFilter = true;

      if (!~accountFeatures.features.indexOf(mtypes.featureEntry.series) && !authView.isActiveAdvancedtrial()) {
        homeState.view.showTypeFilter = false;
        homeState.viewPreferences.typeFilter = 'online';
      }

      $scope.showManageCourses = !!~accountFeatures.features.indexOf(mtypes.featureEntry.coursesMontara);

      $scope.showManageSeries = !!~accountFeatures.features.indexOf(mtypes.featureEntry.seriesMontara);

      var basicTier = authView.getTierDescription() === 'Basic';
      homeState.view.showCreateCourseButton = false; // no longer visible
      homeState.permissions.canCreateSeries = true; // with preview, we always show create series button now
      homeState.view.showSeriesFeaturePreview = !~accountFeatures.features.indexOf(mtypes.featureEntry.series) && !authView.isActiveAdvancedtrial();
      homeState.view.showLiveTraining = !!~accountFeatures.features.indexOf(mtypes.featureEntry.liveTraining);

      homeState.permissions.canCreateCatalog = userRole.canEditCourses;
      homeState.permissions.canCreateCourses = userRole.canEditCourses;
      homeState.permissions.canCreateSeries = userRole.canEditCourses;
      homeState.permissions.canViewCatalogs = userRole.canViewCatalogs;
      homeState.permissions.canViewDraftCourses = userRole.canViewDraftCourses;

      // enforce catalog feature
      if (!~accountFeatures.features.indexOf(mtypes.featureEntry.courseCatalog) && !authView.isActiveAdvancedtrial()) {
        homeState.permissions.canCreateCatalog = false;
      }

      // add values for display
      for (var i = 0, len = items.length; i < len; ++i) {
        if (items[i].type === 'series') {
          items[i].thumbUrl = 'images/home/tn_series.png';
          items[i].status = 'series';
        }
        else if (items[i].type === 'catalog') {
          items[i].thumbUrl = 'images/home/tn_catalog_orange_1.png';
        }
      }

      // search setup
      if (basicTier && !authView.isActiveAdvancedtrial())
        $scope.overridePlaceholder = 'Search by course or trainer';
      else if (homeState.permissions.canViewCatalogs)
        $scope.overridePlaceholder = 'Search by course, series, catalog, or trainer';
      else
        $scope.overridePlaceholder = 'Search by course, series, or trainer';
      var searchSettings = homeSearchService.setup({
        items: items
      });
      $scope.searchSettings = homeState.search.settings = _.extend(searchSettings, {
        gaPageName: trackingService.pages.trainerHome.name,
        filterHasResults: filterHasResults,
        setFilter: setFilter
      });

      var p = homeState.viewPreferences;
      var s = homeState.search;
      s.typeFilter = p.typeFilter;
      s.statusFilter = p.statusFilter;

      applySearchSettings();
    }

    function filterHasResults(fn) {
      var s = homeState.search;
      // ignore filters when searching
      return s.settings.testFilter(fn);
    }

    function setFilter(fn) {
      var s = homeState.search;
      s.compositeSearchFilter = fn;
      applySearchSettings();
    }

    $scope.$watch('homeState.search.typeFilter', function (value) {
      homeState.view.showStatusFilter = !~['all', 'series', 'catalog'].indexOf(value);

      if (!homeState.view.showStatusFilter)
        homeState.search.statusFilter = 'all';

      trackEvent(homeConfig.gaActions.type[value]);
      applySearchSettings();
    });

    $scope.$watch('homeState.search.statusFilter', function (value) {
      trackEvent(homeConfig.gaActions.status[value]);
      applySearchSettings();
    });

    $scope.$watch('homeState.viewPreferences.view', function (value) {
      trackEvent(homeConfig.gaActions.view[value]);
      // show/hide tileview sort dropdown
      showHideSortDropdown(value);
    });

    function applySearchSettings() {
      var s = homeState.search;

      if (s.typeFilter == 'series')
        s.statusFilter = 'all';

      var p = homeState.viewPreferences;
      p.typeFilter = s.typeFilter;
      p.statusFilter = s.statusFilter;

      items = $scope.items = s.settings
        .filterByStatus(s.statusFilter)
        .filterByType(s.typeFilter)
        .filterBy(s.compositeSearchFilter)
        .result();

      applySort();
      validateSelectedItem();
      showHideSortDropdown(p.view);
    }

    function showHideSortDropdown(view) {
      homeState.view.showSortDropdown = view === 'tile' && items.length > 8;
    }

    var applySort = $scope.applySort = function () {
      var p = homeState.viewPreferences;
      var isAsc = p.sortDirection === 'asc';

      if (p.sortField === 'modified')
        $scope.items.sort(sortHelper.getNumericPropertySorter({field: p.sortField, asc: isAsc}));
      else
        $scope.items.sort(sortHelper.getStringPropertySorter({field: p.sortField, asc: isAsc}));
    };

    // if selectedItem is not present in the search results, set it null and close the sidebar
    function validateSelectedItem() {
      if (!homeState.selectedItem) return;

      var found = false;
      for (var i = 0, len = items.length; i < len && !found; ++i) {
        found = items[i].id === homeState.selectedItem.id;
      }
      if (!found)
        closeSidebar();
    }

    $scope.clearSearch = function () {
      var s = homeState.search;
      s.typeFilter = 'all';
      s.statusFilter = 'all';
      s.compositeSearchFilter = null;

      // clears compositeSearchInput
      $rootScope.$broadcast('clearSearchRequested');

      applySearchSettings();
    };

    function refreshHomeItems() {
      homeResource.load(setup);
    }

    var openSidebar = $scope.openSidebar = function () {
      homeState.sidebarContentSrc = homeConfig.sidebarSrcs[homeState.selectedItem.type];
    };

    var closeSidebar = $scope.closeSidebar = function () {
      homeState.sidebarContentSrc = null;
      homeState.selectedItem = null;
    };

    $scope.onHomeItemClick = function (item) {
      trackClickOnTile(item);
      homeState.selectedItem = item;
      openSidebar();
    };

    function trackClickOnTile(item) {
      if (!item
        || !item.id
        || !~homeConfig.sampleCourseIds.indexOf(item.id)
        || homeState.selectedItem === item)
        return;

      trackingService.trackKissMetricsEvent("clicked on", {
        courseId: item.id,
        name: item.name,
        action: "click on tile for right rail"
      });
    }

    $scope.getViewUrl = function () {
      return homeConfig.viewUrls[homeState.viewPreferences.view];
    };

    $scope.getTileClasses = function (item) {
      return (item === homeState.selectedItem ? 'home-tile-selected ' : '') + 'home-tile-' + item.type;
    };

    $scope.getItemUrl = function (item) {
      switch (item.type) {
        case 'catalog':
          return '#/TMS/Catalog/' + item.id;
          break;
        case 'series':
          return '#/TMS/Series/' + item.id;
          break;
        default:
          return '#/TMS/Course_Dashboard/' + item.id;
      }
    };

    $scope.onCreateNewCourseItemClicked = function () {
      trackingService.trackKissMetricsEvent("clicked on", {
        action: "click on create new course tile"
      });
      $scope.createCourse({openCourseAfterCreation: true});
    };

    $scope.openCourse = function (courseId) {
      if (!courseId) return;
      $location.path('/TMS/Course_Dashboard/' + courseId);
    };

    $scope.onOpenCourseLink = function (courseId) {
      if (!~homeConfig.sampleCourseIds.indexOf(courseId))
        return;

      trackingService.trackKissMetricsEvent("clicked on", {
        courseId: courseId,
        action: "clicked the arrow to go straight to the course"
      });
    };

    $scope.createCourse = function (params) {
      var openCourseAfterCreation = params.openCourseAfterCreation;
      $scope.homeState.activeServerCalls.courseCreation = true;

      var fn = homeResource.createCourse;
      if (params.liveCourse)
        fn = homeResource.createLiveCourse;

      fn(function (res) {
        $scope.homeState.activeServerCalls.courseCreation = false;

        if (openCourseAfterCreation)
          return $location.path('/TMS/Course_Dashboard/' + res.courseId);

        closeSidebar();
        refreshHomeItems();
      }, function () {
        $scope.homeState.activeServerCalls.courseCreation = false;
      });
    };

    $scope.createLiveCourse = function (params) {
      $scope.createCourse(_.extend({liveCourse: true}, params));
    };

    $scope.createSeries = function (params) {
      if (!~mfConfig.features.indexOf(mtypes.featureEntry.series) && !authView.isActiveAdvancedtrial()) {
        return $location.path('/TMS/Series/1');
      }

      var s = homeState.search;
      var activeCoursesPresent = s.settings
          .filterByType(['online', 'live'])
          .filterByStatus('active')
          .result().length > 0;
      if (!activeCoursesPresent) {
        return $rootScope.$broadcast('createSeriesNoActiveCoursesMessageRequested');
      }

      var openSeriesAfterCreation = params.openSeriesAfterCreation;
      $scope.homeState.activeServerCalls.seriesCreation = true;

      homeResource.createSeries(function (res) {
        $scope.homeState.activeServerCalls.seriesCreation = false;

        if (openSeriesAfterCreation)
          return $location.path('/TMS/Series/' + res.seriesId);

        refreshHomeItems();
        closeSidebar();
      }, function () {
        $scope.homeState.activeServerCalls.seriesCreation = false;
      });
    };

    $scope.createCatalog = function (params) {
      var openCatalogAfterCreation = params.openCatalogAfterCreation;
      $scope.homeState.activeServerCalls.catalogCreation = true;

      catalogResource.create(function (res) {
        $scope.homeState.activeServerCalls.catalogCreation = false;

        if (openCatalogAfterCreation)
          return $location.path('/TMS/Catalog/' + res.id);

        closeSidebar();
        refreshHomeItems();
      }, function () {
        $scope.homeState.activeServerCalls.catalogCreation = false;
      });
    };

    $scope.$on('courseCopied', _.compose(refreshHomeItems, closeSidebar));
    $scope.$on('courseDeleted', _.compose(refreshHomeItems, closeSidebar));
    $scope.$on('seriesDeleted', _.compose(refreshHomeItems, closeSidebar));
    $scope.$on('catalogDeleted', _.compose(refreshHomeItems, closeSidebar));

    $scope.selectItemById = function (id) {
      for (var i = 0, len = items.length; i < len; i++) {
        if (items[i].id === id)
          return selectItem(items[i]);
      }
    };

    var selectItem = $scope.selectItem = function (item) {
      homeState.selectedItem = item;
      openSidebar();
    };

    $scope.onManageCoursesClicked = function () {
      var hasManageCoursesMontaraFeature = !!~accountFeatures.features.indexOf(mtypes.featureEntry.coursesMontara);
      if (hasManageCoursesMontaraFeature)
        $window.location.href = '/TrainerM/#/courses';
    };

    $scope.onManageSeriesClicked = function () {
      var hasManageSeriesMontaraFeature = !!~accountFeatures.features.indexOf(mtypes.featureEntry.seriesMontara);
      if (hasManageSeriesMontaraFeature)
        $window.location.href = '/TrainerM/#/series';
    };

    $scope.onManageUsersClicked = function () {
      trackEvent(homeConfig.gaActions.click.manageUsersButton);
      var hasManageUsersMontaraFeature = !!~accountFeatures.features.indexOf(mtypes.featureEntry.manageUsersMontara);
      if (hasManageUsersMontaraFeature)
        $window.location.href = '/TrainerM/#/users';
      else
        $location.path('/TMS/ManageUsers');
    };
    $scope.onAdvancedReportsClicked = function () {
      $window.open(authView.getGoodDataUrlForClientDashboard() || "/reports/dashboard");
    };

    $scope.requestSort = function (field) {
      homeState.viewPreferences.sortDirection = field == 'modified' ? 'desc' : 'asc';
      homeState.viewPreferences.sortField = field;
      trackEvent(homeConfig.gaActions.tileViewSort[field]);
      applySort();
    };

    function trackEvent(event) {
      trackingService.trackEvent(trackingService.pages.trainerHome.name, event);
    }

    setup(resolveData);
    actionLogResource.writeActionLog([{action: mtypes.actionType.viewedTrainerDashboard}]);
  }

})();
